<script setup lang="ts">
const { errors = () => [], title = "" } = defineProps<{
  errors?: string | string[] | object | (() => []);
  title?: string;
}>();

const renderedErrors = computed(() => {
  let errorsArray;
  if (Array.isArray(errors)) {
    errorsArray = errors;
  } else if (typeof errors === "string") {
    errorsArray = [errors];
  } else {
    errorsArray = Object.values(errors).flat();
  }
  return errorsArray.filter((error) => !!error);
});
</script>

<template>
  <div v-if="!!renderedErrors.length" class="form-validation-errors">
    <div v-if="title" class="title">{{ title }}</div>
    <ul v-if="renderedErrors?.length > 0" class="list">
      <li v-for="(error, key) in renderedErrors" :key="key">{{ error }}</li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.form-validation-errors {
  font-size: 0.8rem;
  text-align: left;
}
.title {
  font-weight: bold;
}
.list {
  margin: 0;
  padding: 0;
  list-style-type: none;

  li {
    margin: 0;
    padding: 0;

    &::before {
      content: "•";
      margin-right: 0.5em;
    }
  }
}
</style>
